<template>
  <div id="app">
    <div v-if="onLine">
      <router-view />
    </div>
    <div v-else>
      <connectionLost />
    </div>
     <div id="v-idle" style="display: none">
      <!-- :duration in seconds-->
      <v-idle
        @idle="onIdleCheckout"
        name="idle"
        :events="['mousemove', 'keypress', 'ontouchstart', 'onclick']"
        :loop="true"
        :duration="POS_LOCK_SCREEN_TIME * 60"
      />
    </div>
  </div>
</template>

<script>
import Loader from "@/components/Partials/loader.vue";
import connectionLost from "@/components/Partials/connection-lost.vue";
import Modal from "@/components/Partials/globalModal.vue";
import Tooltip from "@/components/UIElements/Tooltip.vue";
import PosService from "@/services/PosService";
import { backendSocket, EventBus } from "@/main.js";
import { BASEURL } from "@/config/index";
export default {
  name: "App",
  components: {
    Loader,
    Modal,
    connectionLost,
    Tooltip,
  },
  data() {
    return {
      onLine: navigator.onLine,
      isTimReady: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    // return store.fetchSpecial(to.params.slug).then(next)
    next();
  },
  beforeMount() {
    Promise.all([
      this.$store.dispatch("fetchGlobalOptions"),
      this.$store.dispatch("fetchOrgDetails"),
    ])
      .then(() => {})
      .catch((error) => {
        console.log(error, "from app");
      });
  },
  beforeDestroy() {
    window.removeEventListener("online", this.updateOnlineStatus);
    window.removeEventListener("offline", this.updateOnlineStatus);
  },
  mounted() {
    window.addEventListener("online", this.updateOnlineStatus);
    window.addEventListener("offline", this.updateOnlineStatus);

    console.log('backendSocket #### CHECK123', backendSocket);

    backendSocket.on("LOGOUT_USER_FROM_ALL_MACHINE", (data) => {
      try {
        let logged_user_id = null;
        const JWTTOKEN = window.localStorage.getItem("JWT_TOKEN");
        const userData = window.localStorage.getItem("USER_INFO")
          ? JSON.parse(window.localStorage.getItem("USER_INFO"))
          : {};
        if (userData.hasOwnProperty("user_id")) {
          logged_user_id = userData.user_id;
        }
        const { token, user_id } = data;
        console.log({ token, user_id }, "from logout data");
        if (
          logged_user_id &&
          logged_user_id != 1 &&
          logged_user_id == user_id &&
          JWTTOKEN !== token
        ) {
          this.onLogout();
        }
      } catch (err) {
        console.log("Error:", err);
        this.onLogout();
      }
    });

    EventBus.$on("ON_TIM_LOG", (data) => {
      if (backendSocket && backendSocket.connected) {
        backendSocket.emit("generate-tim-log", data);
      }
    });

    EventBus.$on("ON_GENERATE_MERCHANT_RECEIPT", (data) => {
      if (backendSocket && backendSocket.connected) {
        backendSocket.emit("generate-merchant-receipts", data);
      }
    });

    EventBus.$on("ON_GENERATE_CARDHOLDER_RECEIPT", (data) => {
      // this.generateTimCardHolderReceipt(data);
    });

    window.addEventListener("onTimReady", (event) => {
      console.log("window event listener onTimReady", event);
      this.isTimReady = event.storage;
      let recaptchaScript = document.createElement("script");
      recaptchaScript.setAttribute("src", `${BASEURL}/Tim/app7.js`);
      document.head.appendChild(recaptchaScript);

      let configObj = {
        pos_id: "",
        ecr_user_id: null,
        ecr_ip_address: "",
        ecr_port: "",
      };

      if (this.$cookie.get("ECR_INFO")) {
        let ECR_INFO = JSON.parse(this.$cookie.get("ECR_INFO"));
        Object.keys(ECR_INFO).map((x) => {
          configObj[x] = ECR_INFO[x];
        });

        if (configObj.ecr_ip_address && configObj.ecr_port) {
          setTimeout((z) => {
            let obj = {
              EventBus: EventBus,
              IPADDRESS: configObj.ecr_ip_address,
              PORT: configObj.ecr_port,
              USERID: configObj.ecr_user_id,
              POSID: configObj.pos_id,
              INTEGRATIONID: "367fcd48-f574-4119-960c-d1ebb00f9a97",
            };
            if (typeof initTimApi == "function") {
              // this.$toasted.show('Tim Ready')
              initTimApi(obj);
              localStorage.setItem("ECR_INIT_STATUS", true);
            }
          }, 1000);
        } else {
          localStorage.setItem("ECR_INIT_STATUS", false);
          console.log("ECR Settings not found");
        }
      } else {
        console.log("ECR Settings not found");
      }
    });
  },
   computed: {
    POS_LOCK_SCREEN_TIME() {
      console.log('this.$store.getters.POS_LOCK_SCREEN_TIME', this.$store.getters.POS_LOCK_SCREEN_TIME);
      return this.$store.getters.POS_LOCK_SCREEN_TIME
    },
   },
  methods: {
      onIdleCheckout() {
      console.log("Idle checkout call close");
      this.onLogout();
    },
    updateOnlineStatus(e) {
      const { type } = e;
      this.onLine = type === "online";
    },
    onLogout: async function () {
      try {
        var userAgent = navigator.userAgent.toLowerCase();
        if (userAgent.indexOf(" electron/") > -1) {
          if (backendSocket && backendSocket.connected) {
            backendSocket.emit("on_user_logout", {
              hardware_id: this.DeviceUniqueCode,
            });
          }
        }

        // window.localStorage.removeItem("JWT_TOKEN");
        // await this.$store.dispatch("onUserShiftQuit", {});
        // await this.updateShiftLogoutData();

        var myItem = null;
        // if (localStorage.getItem("ECR_INFO")) {
        //   myItem = localStorage.getItem("ECR_INFO");
        // }
        window.localStorage.clear();
        // if (myItem) {
        //   localStorage.setItem("ECR_INFO", myItem);
        // }
        this.$router
          .push({
            path: `/`,
          })
          .catch(() => {});
      } catch (err) {
        console.log("Error:", err);
      }
    },
    updateShiftLogoutData: async function () {
      let shiftData = localStorage.getItem("USER_SHIFT_DATA");
      if (shiftData) {
        let payload = JSON.parse(shiftData);
        PosService.OnQuitPosUserShift(payload)
          .then((response) => {
            console.log("user logged out");
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/App.vue